import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import { formValueSelector } from "redux-form";
import Loading from "../../../../components/Loading";
import BoostField from "../../../../components/redux-form/BoostField";
import { loadBoostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty } from "../../../../actions";
import { boostStates } from "../../../../constants";
var selector = formValueSelector("exchangeWizard");
function ExchangeWizardFormBoostStep(props) {
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var price = useSelector(function (state) {
    return selector(state, "price");
  });
  var currency = price.currency;
  var currencyId = currency.id;
  var boosts = useSelector(function (state) {
    return state.entities.boosts.byStateAndCurrencyIdAndUserIdAndOperationsIsEmpty[[boostStates.USABLE, currencyId, authUserId].join("-")];
  });
  useEffect(function () {
    props.loadBoostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty(boostStates.USABLE, currencyId, authUserId);
  });
  if (!boosts) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(BoostField, {
    name: "boost",
    id: "boost",
    boosts: boosts,
    activateCallback: function activateCallback(boost) {
      props.change("investmentItemAmount", boost.amount / price.value);
      props.change("requestedCurrencyAmount", boost.amount);
    },
    deactivateCallback: function deactivateCallback() {
      props.resetSection("investmentItemAmount");
      props.resetSection("requestedCurrencyAmount");
    }
  });
}
export default connect(undefined, {
  loadBoostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty: loadBoostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty
})(ExchangeWizardFormBoostStep);
ExchangeWizardFormBoostStep.propTypes = {
  loadBoostsByStateAndCurrencyIdAndUserIdAndOperationsIsEmpty: PropTypes.func
};